<template>
  <v-container fluid>
       <v-btn color="primary" small text to="/cancel-sale">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
        <!-- editor -->
        <editor
          :initial="dataItem"
          @data="save"
        ></editor>
        <!-- end -->
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import Editor from "./_components/editor.vue";
export default {
  components: {
    Editor,
  },
  data: () => ({
    dataItem: {},
    docCreate: false,
    copyStatus: false
  }),
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true,
    },
  },
  methods: {
    getById(val) {
      const self = this;
      this.$store
        .dispatch("get", `/documents/14/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.dataItem = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    save(data) {
      const url = "/canceled-order";
      // const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            // location.reload();
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
};
</script>